import { http } from '@/http'

export default {
  downloadTemplate() {
    return http.get('/family/template', { responseType: 'blob' })
  },
  validate(file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post('/family/bulk-upload/validate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  confirm(file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post('/family/bulk-upload/confirm', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}
